import { logWrapper } from '../utils';

function selectOnFocusDirectiveFactory(runtimeConstant, element) {
  function run() {
    try {
      // Bind the focus event to select the text in the input field when it gains focus
      element.on('focus', function () {
        this.select();
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  // Wrap the setup function with logWrapper for debugging purposes
  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const selectOnFocusDirective = ['runtimeConstant', 'element', selectOnFocusDirectiveFactory];
